export default __webpack_public_path__ + "static/media/place-2.a893896c.jpg";